import { getInstance } from './instance';

const instance = getInstance();

export const checkoutHostedPage = async (data) => {
  return instance.post('/checkout/one-time-charge-hosted-page', data)
  .then(response => response.data)
  .catch(error => Promise.reject(error));
}

export const getSelfServePortalLink = async (data) => {
  return instance.post('/checkout/portal-session', data)
  .then(response => response.data)
  .catch(error => Promise.reject(error));
}